/**
 * Resource danh mục ngân hàng/kho bạc
 */
export default {
  Title: 'Danh mục ngân hàng',
  BankCode: 'Mã ngân hàng *',
  BankCodeTitle: 'Mã ngân hàng',
  BankName: 'Tên ngân hàng *',
  BankNameTitle: 'Tên ngân hàng',
  Description: 'Ghi chú',
};
